import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import axiosClientHyperWolf from "axiosClient/indexHyperWolf";
import { getQueryString } from "utilities/common";
import { STILO, HYPERWOLF } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))
import { axiosHyperwolfClient } from "axiosClient";

export function getStrainsAPI(data) {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/strain?${getQueryString(data)}`);
}

export function addOrUpdateStrainAPI(data, id = '', ids) {

    if (id) {
        return (adminsMode === STILO ? axiosClientStilo : adminsMode === HYPERWOLF ? axiosHyperwolfClient : axiosClient).put(`api/v1/strain/update/${ids}`, data);
        // return axiosClient.put(`api/v1/strain/update/${id}`, data);

    }
    return (adminsMode === STILO ? axiosClientStilo : adminsMode === HYPERWOLF ? axiosHyperwolfClient : axiosClient).post('api/v1/strain/create', data);
}

export function deleteStrainAPI(id) {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`api/v1/strain/delete/strain/${id}`)
}

export function getAllInfoEffectAPI() {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/admin/products/infoEffects`)
}


export function getSingleStrainAPI(id) {
    if (adminsMode === HYPERWOLF) {
        return axiosClientHyperWolf.get(`/api/v1/strain/${id}?userType=admin`)
    }
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/strain/${id}?userType=admin`)
}

// Main Strain API
export function getMainStrainsAPI() {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).get('api/v1/strain/main/page');
}

export function updateMainStrainAPI(data) {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`api/v1/strain/update/main/metas`, data);
}

export function getFlavorsAPI() {
    return (adminsMode === STILO ? axiosClientStilo : axiosClient).get('api/v1/strain/get/all/flavors');
}